$(function () {
//  Tab Functionality
  var el = $('.invicta-tabs');
  var tabs = el.find('.invicta-tabs__headings .tab');
  var tab_content = el.find('.invicta-tabs__content .tab-content');

  tabs.on('click', function () {
    tabs.removeClass('active');
    $(this).addClass('active');
    tab_content.removeClass('active');
    tab_content.eq($(this).index()).addClass('active');
  });

});



// WEBPACK FOOTER //
// ./scripts/components/tabs.js